export default __webpack_public_path__ + "static/Partnership-f9a3113d69c4160f226774800e512b5b.gif";